export async function fetchJson(url, fallback) {
    try {
        const response = await fetch(url);

        if (!response.ok) {
            return fallback;
        }

        return await response.json();
    } catch (error) {
        console.error(`Failed to fetch ${url}:`, error);
        return fallback;
    }
}